const getSpecialTranslation=(text,t)=>t(text)!==text?t(text):false;

export default  getSpecialTranslation;